import { render, staticRenderFns } from "./TicimaxV2OrderStatus.vue?vue&type=template&id=06fdca75"
import script from "./TicimaxV2OrderStatus.vue?vue&type=script&lang=js"
export * from "./TicimaxV2OrderStatus.vue?vue&type=script&lang=js"
import style0 from "./TicimaxV2OrderStatus.vue?vue&type=style&index=0&id=06fdca75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports